import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';

import { getTwitchOAuth } from 'src/store/auth';

import { CustomButton } from 'src/components';

import { CheckOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import './pricing.scss';

export const Pricing = () => {
  const { t } = useTranslation('pricing');

  const dispatch = useDispatch();

  const onClickConnect = useCallback(() => {
    dispatch(getTwitchOAuth());
  }, [dispatch]);

  const plans = t('plans', { returnObjects: true });
  const disclaimerText = t('disclaimer.text');
  const disclaimerPoints = t('disclaimer.points', { returnObjects: true });

  return (
    <section id="pricing" className="landing__pricing">
      <h2 className="landing__section-title">{t('title')}</h2>
      <div className="landing__pricing-grid">
        {plans.map((plan) => {
          const planClassName = `landing__plan${plan.highlight ? ' landing__plan--highlight' : ''}`;
          const planItems = plan.items;

          return (
            <div className={planClassName} key={plan.name}>
              {plan.badge ? <div className="landing__badge">{plan.badge}</div> : null}
              <h3 className="landing__plan-name">{plan.name}</h3>
              <div className="landing__plan-price">{plan.price}</div>
              <ul className="landing__plan-list">
                {planItems.map((item, index) => (
                  <li className="landing__plan-item" key={`${plan.name}-${index}`}>
                    <CheckOutlined /> {item.text}
                    {item.tooltip ? (
                      <Tooltip title={item.tooltip}>
                        <QuestionCircleOutlined />
                      </Tooltip>
                    ) : null}
                  </li>
                ))}
              </ul>
              <CustomButton title={plan.cta} onClick={onClickConnect} />
            </div>
          );
        })}
      </div>
      <div className="landing__plan-description" style={{}}>
        {disclaimerText}
        <ul style={{ marginBottom: 0 }}>
          {disclaimerPoints.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      </div>
    </section>
  );
};
